<pkr-player-pot *ngFor="let player of players" [player]="player" [toPot]="player.toPot.value" [gameTable]="gameTable"> </pkr-player-pot>
